<div class="feedback-rating" role="group" aria-label="Rate this response" data-testid="feedback-rating-container">
	<app-button
		[class.selected-up]="isThumbsUp"
		variant="icon"
		category="action"
		size="xs"
		[iconName]="isThumbsUp ? 'thumb_up' : 'thumb_up_off_alt'"
		tooltip="Helpful"
		[onClick]="onThumbsUpAction"
		aria-label="Thumbs up"
	>
	</app-button>
	<app-button
		[class.selected-down]="isThumbsDown"
		variant="icon"
		category="action"
		size="xs"
		[iconName]="isThumbsDown ? 'thumb_down' : 'thumb_down_off_alt'"
		tooltip="Not helpful"
		[onClick]="onThumbsDownAction"
		aria-label="Thumbs down"
	>
	</app-button>
</div>

@if (showFeedbackForm) {
	<div class="feedback-form" data-testid="feedback-rating-panel-form">
		<span class="feedback-prompt">What went wrong?</span>
		<div class="feedback-categories">
			@for (cat of categories; track cat) {
				<button class="category-chip" [class.selected]="cat.selected" (click)="toggleCategory(cat)" data-testid="feedback-rating-btn-category">
					{{ cat.label }}
				</button>
			}
		</div>
		<button class="submit-feedback" (click)="submitDetailedFeedback()" data-testid="feedback-rating-btn-submit">Submit</button>
	</div>
}
